import App from "./App.vue";
import Dashboard from "./components/Dashboard/Dashboard.vue";
import DashOption from "./components/Dashboard/DashOption.vue";
import Reports from "./components/Reports/Reports.vue";
import Setup from "./components/Setup/Setup.vue";
import Site from "./components/Setup/Site.vue";
import SiteAdjust from "./components/Settings/SiteAdjust.vue";
import Station from "./components/Setup/Station.vue";
import Settings from "./components/Settings/Settings.vue";
import Login from "@monolith/components/src/Login.vue";
import Signup from "./components/Auth/Signup.vue";
import Validate from "./components/Auth/Validate.vue";
import WaitingForValidation from "./components/Auth/WaitingForValidation.vue";
import POSPage from "./components/Stations/POS/POSPage.vue";
import GEOPage from "./components/Stations/GEO/GEOPage.vue";
import KDSPage from "./components/Stations/KDS/KDSPage.vue";
import MONPage from "./components/Stations/MON/MONPage.vue";
import WebPage from "./components/Web/WebPage.vue";
import SatellitePage from "./components/Stations/Satellite/SatellitePage.vue";
import WebSettings from "./components/Web/WebSettings.vue";
import SiteMenu from "./components/Menus/SiteMenu.vue";
import FloorPlan from "./components/Stations/Satellite/FloorPlan.vue";
import Billing from "./components/Billing/Billing.vue";
import StripeDash from "./components/Billing/StripeDash.vue";
import TrainingDash from "./components/Training/TrainingDash.vue";
import TrainingForm from "./components/Training/TrainingForm.vue";
import ActiveForm from "./components/Training/ActiveForm.vue";
import FormTemplates from "./components/Training/FormTemplates.vue";
import Roles from "./components/Training/Roles.vue";
import PasswordReset from "./components/Auth/PasswordReset.vue";
import { createStore } from "vuex";
import { state, token, geo, training } from "@monolith/store";
import { createApp } from "vue";
import Notifications from "@kyvg/vue3-notification";
import { jwtDecode } from "jwt-decode";
import DeliveryZone from "./components/Web/DeliveryZone.vue";
import MenuManager from "./components/Menus/MenuManager.vue";
import XeroPage from "./components/Settings/XeroPage.vue";
import COGSDashboard from "./components/COGS/Dashboard.vue";
import COGSProducts from "./components/COGS/Products.vue";
import COGSSiteMenus from "./components/COGS/SiteMenus.vue";
import COGSBaseRecipes from "./components/COGS/BaseRecipes.vue";
import { hours } from "@monolith/helpers"

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser,
  faSatellite,
  faCircleHalfStroke,
  faSun,
  faMoon,
  faPhone,
  faEdit,
  faPlus,
  faMinus,
  faSave,
  faTrash,
  faBars,
  faSort,
  faSortUp,
  faSortDown,
  faMinusCircle,
  faPlusCircle,
  faEnvelope,
  faHouse,
  faPlug,
  faChartPie,
  faChartLine,
  faGears,
  faRightFromBracket,
  faMoneyBillWave,
  faCheck,
  faWifi,
  faTimes,
  faWrench,
  faArrowRight,
  faArrowLeft,
  faChevronRight,
  faChevronLeft,
  faLink,
  faPencil,
  faFloppyDisk,
  faCaretDown,
  faCaretRight,
  faPenToSquare,
  faUtensils,
  faCashRegister,
  faArrowUpWideShort,
  faGlobe,
  faMeteor,
  faUserAstronaut,
  faMagnifyingGlass,
  faBackward,
  faWarehouse,
  faPersonChalkboard,
  faFileExport,
  faBox,
  faTruck,
  faClipboardList,
  faTags,
  faFolderOpen,
  faCalculator,
  faSyncAlt,
  faCopy,
  faChevronDown,
  faCarrot,
  faBook,
	faTruckFast,
  faPeopleGroup,
  faUserTag,
  faUsers,
  faPen,
  faStar,
  faFileLines,
	faEye,
	faThermometerHalf,
  faSpinner
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faSatellite,
  faCircleHalfStroke,
  faSun,
  faMoon,
  faPhone,
  faEdit,
  faPlus,
  faMinus,
  faSave,
  faTrash,
  faBars,
  faSort,
  faSortUp,
  faSortDown,
  faMinusCircle,
  faPlusCircle,
  faEnvelope,
  faHouse,
  faPlug,
  faChartPie,
  faChartLine,
  faGears,
  faRightFromBracket,
  faMoneyBillWave,
  faCheck,
  faWifi,
  faTimes,
  faWrench,
  faArrowRight,
  faArrowLeft,
  faChevronRight,
  faChevronLeft,
  faLink,
  faPencil,
  faFloppyDisk,
  faCaretDown,
  faCaretRight,
  faPenToSquare,
  faUtensils,
  faCashRegister,
  faArrowUpWideShort,
  faGlobe,
  faMeteor,
  faUserAstronaut,
  faMagnifyingGlass,
  faBackward,
  faWarehouse,
  faPersonChalkboard,
  faFileExport,
  faBox,
  faTruck,
  faClipboardList,
  faTags,
  faFolderOpen,
  faCalculator,
  faSyncAlt,
  faCopy,
  faChevronDown,
  faCarrot,
  faBook,
	faTruckFast,
  faUser,
  faPeopleGroup,
  faUserTag,
  faUsers,
  faPen,
  faStar,
  faFileLines,
	faEye,
	faThermometerHalf,
  faSpinner
);

import { createRouter, createWebHistory } from "vue-router";
import ConfirmPassReset from "./components/Auth/ConfirmPassReset.vue";

const store = createStore({
  modules: { token: token, state: state, geo: geo, training: training },
});
export default store;

const router = new createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: Login },
    { path: "/login", name: "Login", component: Login },
    { path: "/login/:error", name: "LoginError", component: Login },
    { path: "/signup", name: "Signup", component: Signup },
    { path: "/signup/waiting-for-validation", name: "WaitingForValidation", component: WaitingForValidation },
    { path: "/billing", name: "Billing", component: Billing, meta: { requiresAuth: true, needsStripe: true } },
    { path: "/dashboard", component: DashOption, meta: { requiresAuth: true } },
    { path: "/dashopt", component: DashOption, meta: { requiresAuth: true } },
    { path: "/dashboard/:site", component: Dashboard, meta: { requiresAuth: true, needsPOS: true, needsCogs: true } },
    { path: "/pos", component: POSPage, meta: { requiresAuth: true, needsPOS: true, needsStripe: true } },
    { path: "/sat", component: SatellitePage, meta: { requiresAuth: true, needsPOS: true } },
    { path: "/kds", component: KDSPage, meta: { requiresAuth: true, needsStripe: true } },
    { path: "/geo", component: GEOPage, meta: { requiresAuth: true, needsStripe: true } },
    { path: "/mon", component: MONPage, meta: { requiresAuth: true } },
    { path: "/web", component: WebPage, meta: { requiresAuth: true } },
    { path: "/web/:site", component: WebSettings, meta: { requiresAuth: true } },
    { path: "/reports/:site", component: Reports, meta: { requiresAuth: true } },
    { path: "/reports/:site/:dataType", name: "reports", component: Reports, meta: { requiresAuth: true } },
    { path: "/reports", component: Reports, meta: { requiresAuth: true } },
    { path: "/setup/company", component: Setup, meta: { requiresAuth: true } },
    { path: "/setup/site", component: Site, meta: { requiresAuth: true } },
    { path: "/setup/site-setup", name: "site-setup", component: Site, meta: { requiresAuth: true } },
    { path: "/setup/station", component: Station, meta: { requiresAuth: true } },
    { path: "/validate/:token", name: "Validate", component: Validate, meta: { requiresAuth: false } },
    { path: "/settings", name: "Settings", component: Settings, meta: { requiresAuth: true } },
    { path: "/settings/xero", component: XeroPage, meta: { requiresAuth: true } },
    { path: "/settings/payments", name: "StripeDash", component: StripeDash, meta: { requiresAuth: true, needsStripe: true } },
    { path: "/settings/:site", component: SiteAdjust, meta: { requiresAuth: true, needsPOS: true } },
    { path: "/cogs", name: "cogs", component: COGSDashboard, meta: { requiresAuth: true, needsPOS: true, needsCogs: true } },
    { path: "/cogs/products", name: "cogs-products", component: COGSProducts, meta: { requiresAuth: true, needsPOS: true, needsCogs: true } },
    { path: "/cogs/base-recipes", name: "base-recipes", component: COGSBaseRecipes, meta: { requiresAuth: true, needsPOS: true, needsCogs: true } },
    { path: "/cogs/site-menus", name: "site-menus", component: COGSSiteMenus, meta: { requiresAuth: true, needsPOS: true, needsCogs: true } },
    { path: "/menus", name: "menus", component: MenuManager, meta: { requiresAuth: true, needsPOS: true } },
    { path: "/menus/:site", name: "site-menu", component: SiteMenu, meta: { requiresAuth: true, needsPOS: true } },
    { path: "/menus/:site/:tab", name: "site-menu-tab", component: SiteMenu, meta: { requiresAuth: true, needsPOS: true } },
    { path: "/menus/:site/:tab/:set?/:item?", name: "site-menu-tab", component: SiteMenu, meta: { requiresAuth: true, needsPOS: true } },
    { path: "/send-reset", name: "send-reset", component: PasswordReset, meta: { requiresAuth: false } },
    { path: "/user/:usage/:token", name: "password", component: ConfirmPassReset, meta: { requiresAuth: false } },
    { path: "/floorplan/:site", name: "floor-plan", component: FloorPlan, meta: { requiresAuth: true } },
    { path: "/deliveryzone/:site", name: "delivery-zone", component: DeliveryZone, meta: { requiresAuth: true } },
    { path: "/training/dashboard", name: "TrainingDash", component: TrainingDash, meta: { requiresAuth: true } },
    { path: "/training/form", name: "TrainingForm", component: TrainingForm, meta: { requiresAuth: true } },
    { path: "/training/active/:formID/:staffID", name: "ActiveForm", component: ActiveForm, meta: { requiresAuth: true } },
    { path: "/training/templates", name: "FormTemplates", component: FormTemplates, meta: { requiresAuth: true } },
    { path: "/training/roles", name: "Roles", component: Roles, meta: { requiresAuth: true } },

  ],
  scrollBehavior() {
    return new Promise((resolve) => {
      resolve({ left: 0, top: 0 });
    });
  },
});

const isAuthenticated = async () => {
  let token = localStorage.getItem("token");
  if (token) {
    const decoded = jwtDecode(token);
    const now = parseInt(Date.now() / 1000);
    if (decoded.exp < now) {
      return false;
    }
    return true;
  } else {
    return false;
  }
};

router.beforeEach(async (to, from, next) => {
  const authenticated = await isAuthenticated();
  if (to.meta.requiresAuth) {
    if (authenticated) {
      if (JSON.parse(localStorage.getItem("sites")).length == 0 && to.name !== "site-setup") {
        return next({ name: "site-setup" });
      }
      const willLoadCore = !state.state.siteMapLoaded;
      const willLoadPOS = to.meta.needsPOS && !state.state.posDataLoaded;
      const willLoadStripe = to.meta.needsStripe && !state.state.stripeDataLoaded;
      const willLoadCogs = to.meta.needsCogs && !state.state.cogsDataLoaded;

      if (willLoadCore || willLoadPOS || willLoadStripe || willLoadCogs) {
        store.dispatch("loading", true);
      }

      if (willLoadCore) {
        await store.dispatch("loadCoreData");
      }

      const lazyLoads = [];
      if (to.meta.needsPOS) lazyLoads.push(store.dispatch("loadPOSData"));
      if (to.meta.needsStripe) lazyLoads.push(store.dispatch("loadStripeData"));
      if (to.meta.needsCogs) lazyLoads.push(store.dispatch("loadCogsData"));
      if (lazyLoads.length) await Promise.all(lazyLoads);

      if (willLoadCore || willLoadPOS || willLoadStripe || willLoadCogs) {
        store.dispatch("loading", false);
      }

      return next();
    }
    return next({ name: "Login" });
  }
  return next();
});

const app = createApp(App);
app.config.globalProperties.$hours = hours;
app
  .use(Notifications)
  .use(router)
  .use(store)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
